import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './QuickSupport.css';

function QuickSupport() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [activeTab, setActiveTab] = useState('contact');

  const whatsappPhoneNumber = '917852034945';
  const whatsappPrefillMessage = 'I have a Doubt related to courses';
  const whatsappUrl = `https://wa.me/${whatsappPhoneNumber}?text=${encodeURIComponent(whatsappPrefillMessage)}`;

  const supportEmail = 'info@durbhasigurukulam.com';
  const emailSubject = 'Course Support Inquiry';
  const emailBody = 'I have a Doubt related to courses';
  const mailtoUrl = `mailto:${supportEmail}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent successfully! We will get back to you soon.');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const supportChannels = [
    {
      icon: '💬',
      title: 'WhatsApp Chat',
      description: 'Chat with our support team on WhatsApp',
      availability: '24/7 Available',
      color: '#25D366',
      onClick: () => window.open(whatsappUrl, '_blank', 'noopener,noreferrer')
    },
    {
      icon: '📧',
      title: 'Email Support',
      description: `Email us at ${supportEmail}`,
      availability: 'Response in 24hrs',
      color: '#43e97b',
      onClick: () => window.open(mailtoUrl, '_self')
    },
    {
      icon: '📞',
      title: 'Phone Support',
      description: 'Call us at +91 7852034945',
      availability: 'Mon-Fri 9AM-6PM',
      color: '#fa709a',
      onClick: () => window.open('tel:+917852034945', '_self')
    },
    {
      icon: '📚',
      title: 'Knowledge Base',
      description: 'Browse our comprehensive help articles',
      availability: 'Always Available',
      color: '#4facfe',
      onClick: () => setActiveTab('faq')
    }
  ];

  const faqs = [
    {
      question: 'How do I enroll in a course?',
      answer: 'Simply browse our courses, select the one you want, and click the "Enroll Now" button. Follow the payment process to get instant access.'
    },
    {
      question: 'Do courses have lifetime access?',
      answer: 'Yes, once you enroll in a course, you have lifetime access to all course materials, including future updates.'
    },
    {
      question: 'Are certificates provided?',
      answer: 'Yes, upon successful completion of a course, you will receive a certificate that you can share on LinkedIn and your resume.'
    },
    {
      question: 'Is there a mobile app?',
      answer: 'We will try to provide a mobile app as soon as possible, but it is not guaranteed.'
    }
  ];

  const [expandedFaq, setExpandedFaq] = useState(null);

  return (
    <div className="quick-support-page">
      <div className="support-header">
        <div className="container">
          <button className="back-btn" onClick={() => navigate('/')}>
            ← Back to Home
          </button>
          <h1 className="page-title">Quick Support</h1>
          <p className="page-subtitle">We're here to help you succeed. Get in touch with us!</p>
        </div>
      </div>

      <div className="container">
        <div className="support-tabs">
          <button
            className={`tab-btn ${activeTab === 'contact' ? 'active' : ''}`}
            onClick={() => setActiveTab('contact')}
          >
            Contact Us
          </button>
          <button
            className={`tab-btn ${activeTab === 'faq' ? 'active' : ''}`}
            onClick={() => setActiveTab('faq')}
          >
            FAQ
          </button>
        </div>

        {activeTab === 'contact' && (
          <div className="tab-content">
            <div className="support-channels">
              <h2 className="section-heading">Choose Your Support Channel</h2>
              <div className="channels-grid">
                {supportChannels.map((channel, index) => (
                  <button
                    key={index}
                    type="button"
                    className="channel-card"
                    onClick={channel.onClick}
                  >
                    <div className="channel-icon" style={{ background: `linear-gradient(135deg, ${channel.color} 0%, ${channel.color}dd 100%)` }}>
                      {channel.icon}
                    </div>
                    <h3 className="channel-title">{channel.title}</h3>
                    <p className="channel-description">{channel.description}</p>
                    <div className="channel-availability">{channel.availability}</div>
                  </button>
                ))}
              </div>
            </div>

            <div className="contact-section">
              <div className="contact-grid">
                <div className="contact-info">
                  <h2 className="section-heading">Get In Touch</h2>
                  <p className="contact-description">
                    Have questions? We're here to help. Fill out the form and our team will get back to you within 24 hours.
                  </p>

                  <div className="info-items">
                    <div className="info-item">
                      <span className="info-icon">📍</span>
                      <div>
                        <h4>Office Address</h4>
                        <p>2.,P. NO. 18, Radha Vihar, Manchwa, Jaipur, Rajasthan 303706</p>
                      </div>
                    </div>
                    <div className="info-item">
                      <span className="info-icon">📧</span>
                      <div>
                        <h4>Email Address</h4>
                        <p>
                          <a href={mailtoUrl}>{supportEmail}</a>
                        </p>
                      </div>
                    </div>
                    <div className="info-item">
                      <span className="info-icon">📞</span>
                      <div>
                        <h4>Phone Number</h4>
                        <p>
                          <a href="tel:+917852034945">+91 7852034945</a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="social-links">
                    <h4>Follow Us</h4>
                    <div className="social-icons">
                      <button className="social-icon" onClick={() => window.open('https://x.com/Dgpl_00', '_blank', 'noopener,noreferrer')} aria-label="X">𝕏</button>
                      <button className="social-icon" onClick={() => window.open('https://www.instagram.com/durbhasi_gurukulam/', '_blank', 'noopener,noreferrer')} aria-label="Instagram">📸</button>
                      <button className="social-icon" onClick={() => window.open('https://linkedin.com/company/durbhasi-gurukulam', '_blank', 'noopener,noreferrer')} aria-label="LinkedIn">💼</button>
                    </div>
                  </div>
                </div>

                <div className="contact-form-wrapper">
                  <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="name">Full Name</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="John Doe"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email Address</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="john@example.com"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Subject</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        placeholder="How can we help you?"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message</label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Write your message here..."
                        rows="5"
                        required
                      ></textarea>
                    </div>

                    <button type="submit" className="submit-btn">
                      Send Message 📨
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'faq' && (
          <div className="tab-content">
            <div className="faq-section">
              <h2 className="section-heading">Frequently Asked Questions</h2>
              <p className="faq-subtitle">Find answers to common questions about our platform</p>

              <div className="faq-list">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`faq-item ${expandedFaq === index ? 'expanded' : ''}`}
                    onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                  >
                    <div className="faq-question">
                      <h3>{faq.question}</h3>
                      <span className="faq-icon">{expandedFaq === index ? '−' : '+'}</span>
                    </div>
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="still-need-help">
              <h3>Still Need Help?</h3>
              <p>Can't find what you're looking for? Contact our support team</p>
              <button className="help-btn" onClick={() => setActiveTab('contact')}>
                Contact Support
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default QuickSupport;
